import { PALETTE } from '../styles/palette';

export interface RasterImage {
  width: number;
  height: number;
  data: Uint8Array;
}

/**
 * Паттерны для карты рисуются на canvas в рантайме: внешних ассетов у
 * прототипа нет, а статус нельзя показывать одним цветом.
 * Возвращает null, если canvas недоступен — слой просто не добавится.
 */
function drawPattern(
  size: number,
  paint: (ctx: CanvasRenderingContext2D, size: number) => void,
): RasterImage | null {
  if (typeof document === 'undefined') return null;
  const canvas = document.createElement('canvas');
  canvas.width = size;
  canvas.height = size;
  const ctx = canvas.getContext('2d');
  if (!ctx) return null;

  ctx.clearRect(0, 0, size, size);
  paint(ctx, size);

  const image = ctx.getImageData(0, 0, size, size);
  return { width: size, height: size, data: new Uint8Array(image.data.buffer.slice(0)) };
}

/** 45° штриховка — «ожидается / ещё не срок». Только этот смысл. */
export function hatch45(color = PALETTE.active, size = 8): RasterImage | null {
  return drawPattern(size, (ctx, s) => {
    ctx.strokeStyle = color;
    ctx.lineWidth = 1.5;
    ctx.beginPath();
    ctx.moveTo(-s, s);
    ctx.lineTo(s, -s);
    ctx.moveTo(0, s * 2);
    ctx.lineTo(s * 2, 0);
    ctx.stroke();
  });
}

/** Перекрёстная штриховка — «демо / синтетика», исключается из фактических сумм. */
export function hatchCross(color = PALETTE.muted, size = 10): RasterImage | null {
  return drawPattern(size, (ctx, s) => {
    ctx.strokeStyle = color;
    ctx.lineWidth = 1;
    ctx.beginPath();
    ctx.moveTo(-s, s);
    ctx.lineTo(s, -s);
    ctx.moveTo(0, s * 2);
    ctx.lineTo(s * 2, 0);
    ctx.moveTo(-s, 0);
    ctx.lineTo(s, s * 2);
    ctx.moveTo(0, -s);
    ctx.lineTo(s * 2, s);
    ctx.stroke();
  });
}

export const HATCH_PENDING = 'hatch-pending';
export const HATCH_DEMO = 'hatch-demo';
